
import { CampagneModel } from "@/app/entities";
import { DashboardHeader, SideImageCard, UiButton } from "@/components";
import { CampagneForm } from "@/components/molecules";
import { useCampagne } from "@/composables/campagne";
import { useToast } from "@/composables/toast";
import { ArrowLeft } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function NouvelCampagne() {
  const { reference } = useParams<{ reference: string }>();
  const navigate = useNavigate();
  const { getCampagneByReference } = useCampagne();
  const [campagne, setCampagne] = useState<CampagneModel | undefined>(
    undefined
  );

  useEffect(() => {
    if (!reference) {
      navigate(-1);
      return;
    }
    const theCampain = getCampagneByReference(reference);
    if (!theCampain) {
      useToast("Campagne introuvable", {
        variant: "error",
      });
      return;
    }
    setCampagne(theCampain);
  }, [reference]);

  return (
    <>
      <DashboardHeader subTitle="Bienvenue aux campagnes" />

      <div className="py-4">
        <SideImageCard imgSrc="/assets/images/chris-lee-70l1tDAI6rM-unsplash 1.png">
          <div className="">
            <UiButton
              variant="text"
              onClick={() => navigate(-1)}
              startIcon={<ArrowLeft />}
            >
              Retour
            </UiButton>

            <CampagneForm initialValue={campagne} />
          </div>
        </SideImageCard>
      </div>
    </>
  );
}
